<mat-card appearance="raised">
  <mat-card-header>
    <mat-card-title>API Keys</mat-card-title>
  </mat-card-header>

  <mat-card-content class="mat-card-content-lg no-bottom-padding">
    <ifc-horizontal-list [items]="listItems">
      <ng-template horizontalListCustomTemplate="enabledCheckBoxValue">
        <mat-checkbox [(ngModel)]="broker.apiEnabled"
                      [disabled]="!canEdit"
                      (change)="update($event.checked)"
                      color="primary"></mat-checkbox>
      </ng-template>
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
